module.exports = __webpack_public_path__ + "img/img1.9693dde8.png";